module.exports = __webpack_public_path__ + "media/images/icon__arrow-left--rb-gray@2x-b4bf36c5fd0b999fb4cd7026b545e1fe.png";